import { RefObject, useContext, useEffect, useRef, useState } from 'react'
import { PositionContext } from './ModalPositionProvider'

type offsetHeightValues = {
  offsetHeight: number
  titleRef: RefObject<HTMLParagraphElement>
  bottomRef: RefObject<HTMLDivElement>
}

export const useOffsetHeight = (): offsetHeightValues => {
  const { top, bottom } = useContext(PositionContext)
  const titleRef = useRef<HTMLParagraphElement>(null)
  const bottomRef = useRef<HTMLDivElement>(null)
  const [offsetHeight, setOffsetHeight] = useState<number>(0)

  useEffect(() => {
    setTimeout(() => {
      const titleHeight = titleRef.current ? titleRef.current.offsetHeight : 0
      const bottomHeight = bottomRef.current
        ? bottomRef.current.offsetHeight
        : 0
      setOffsetHeight(titleHeight + bottomHeight)
    }, 0)
  }, [top, bottom])

  return {
    offsetHeight,
    titleRef,
    bottomRef,
  }
}
